import styled from "styled-components";

export const IconButtonStyled = styled.button`
  position: relative;
  width: 100%;
  padding: 0 20px;
  height: 40px;
  border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
  border-radius: 21px;
  display: flex;
  align-items: center;
  background: transparent;
  cursor: pointer;
  .icon {
    position: absolute;
    left: 20px;
    display: flex;
    align-items: center;
  }
  .label {
    flex: 1;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_11};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
`;
